import toast from "react-hot-toast"
import { setAllBanners, setAllFeatureFlags, setAllUsers, setSignInData, setToken } from "../../slices/authSlice"
import { deleteCookie, setObjectInCookie } from "../../utils/Utils"
import { authEndpoints } from "../api"
import { apiConnector } from "../apiConnector"


const { LOGIN_IN, LOGOUT_IN, SET_USER_IN, ADD_BANNER, REMOVE_BANNER, GET_ALL_BANNERS, EDIT_BANNER, GET_ALL_FEATURE_FLAGS, REMOVE_FEATURE_FLAG, EDIT_FEATURE_FLAG, ADD_FEATURE_FLAG, DELETE_ACCOUNT, ALL_USERS, DELETE_USER } = authEndpoints

export function login(userName, password, navigate) {
    return async (dispatch) => {
        try {
            const response = await apiConnector("POST", LOGIN_IN, { userName, password })

            if (response.data.success && response.data.userData) {
                setObjectInCookie('userData', response.data.userData, 7)
                setSignInData(response.data.userData)
                setToken(response.data.token)
                toast.success("Login Successful")
                window.location.reload()
                navigate(`/admin`)
            }
        } catch (error) {
            toast.error(error.response.data.message)
        }
    }
}

export function setUser(userName, email, password, role) {
    return async (dispatch) => {
        try {
            const response = await apiConnector("POST", SET_USER_IN, { userName, email, password, role })
            if (response.data.success) {
                toast.success(`${userName} Added Successfully`)

            } else {
                toast.error(`${userName} Already Exists`)
            }
        } catch (error) {
            toast.error(error.response.data.message)
        }
    }
}
export function getAllUsers() {
    return async (dispatch) => {
        try {
            const response = await apiConnector("GET", ALL_USERS)
            if (response.data.success) {
                dispatch(setAllUsers(response.data.result))
            }
            
        } catch (error) {
            toast.error(error.response.data.message)
        }
    }
}
export function deleteUser(userName) {
    return async (dispatch) => {
        try {
            const response = await apiConnector("POST", DELETE_USER, {userName})
            if (response.data.success) {
                dispatch(getAllUsers())
                toast.success(`${userName} Deleted Successfully`)

            }
        } catch (error) {
            toast.error(error.response.data.message)
        }
    }
}

export function logout(navigate) {
    return async (dispatch) => {
        try {
            const response = await apiConnector("POST", LOGOUT_IN)

            if (response.data.success) {
                deleteCookie('userData')
                setSignInData({})
                setToken(null)
                localStorage.removeItem("tuf")
                toast.success("Logout Successful")
                window.location.reload()
                navigate(`/`)
            }
        } catch (error) {
            if (error.response.status === 401) {
                toast.error("Session Expired")
                deleteCookie('userData')
                setSignInData({})
                setToken(null)
                localStorage.removeItem("tuf")
                window.location.reload()
            }
        }
    }
}

export function addBaner(heading, description, hasIcon, icon, hasTargetDate, targetDate, availNowRoute, isActive, setModalOpen) {
    return async (dispatch) => {
        try {
            const response = await apiConnector("POST", ADD_BANNER, { heading, description, hasIcon, icon, hasTargetDate, targetDate, availNowRoute, isActive })
            if (response.data.success) {
                if(setModalOpen) {
                    setModalOpen(false)
                }
                toast.success("Banner ADDED Successfully")
                dispatch(getAllBanners())
            }
        } catch (error) {
            console.log(error)
        }
    }
}
export function editBanner(heading, description, hasIcon, icon, hasTargetDate, targetDate, availNowRoute, isActive, setModalOpen, id) {
    return async (dispatch) => {
        try {
            const response = await apiConnector("PUT", EDIT_BANNER, { heading, description, hasIcon, icon, hasTargetDate, targetDate, availNowRoute, isActive, id })
            if (response.data.success) {
                if(setModalOpen) {
                    setModalOpen(false)
                }
                toast.success("Banner EDITED Successfully")
                dispatch(getAllBanners())
            }
        } catch (error) {
            console.log(error)
        }
    }
}
export function getAllBanners() {
    return async (dispatch) => {
        try {
            const response = await apiConnector("GET", GET_ALL_BANNERS)
            dispatch(setAllBanners(response.data.result))

        } catch (error) {
            console.log(error)
        }
    }
}
export function removeBanner(id) {
    return async (dispatch) => {
        try {
            const response = await apiConnector("POST", REMOVE_BANNER, { id })

            if (response.data.success) {
                toast.success("Banner Removed Successfully")
                dispatch(getAllBanners())
            }
        } catch (error) {
            console.log(error)
        }
    }
}
export function getAllFeatureFlags() {
    return async (dispatch) => {
        try {
            const response = await apiConnector("GET", GET_ALL_FEATURE_FLAGS)
            dispatch(setAllFeatureFlags(response.data.result))

        } catch (error) {
            console.log(error)
        }
    }
}
export function removeFeatureFlag(id) {
    return async (dispatch) => {
        try {
            const response = await apiConnector("POST", REMOVE_FEATURE_FLAG, { id })

            if (response.data.success) {
                toast.success("Banner Removed Successfully")
                dispatch(getAllFeatureFlags())
            }
        } catch (error) {
            console.log(error)
        }
    }
}
export function editFeatureFlag(feature, isVisible, content, id, setModalOpen) {
    return async (dispatch) => {
        try {
            const response = await apiConnector("PUT", EDIT_FEATURE_FLAG, { feature, isVisible, content, id })
            if (response.data.success) {
                if(setModalOpen) {
                    setModalOpen(false)
                }
                toast.success("Feature Flag EDITED Successfully")
                dispatch(getAllFeatureFlags())
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export function addFeatureFlag(feature, isVisible, content, setModalOpen) {
    return async (dispatch) => {
        try {
            const response = await apiConnector("POST", ADD_FEATURE_FLAG, { feature, isVisible, content})
            if (response.data.success) {
                if(setModalOpen) {
                    setModalOpen(false)
                }
                toast.success("Feature Flag Added Successfully")
                dispatch(getAllFeatureFlags())
            }
        } catch (error) {
            console.log(error)
        }
    }
}
export function deleteAccount(email) {
    return async (dispatch) => {
        const toastId =toast.loading("Deleting Account...")
        try {
            const response = await apiConnector("POST", DELETE_ACCOUNT, { email})
            if (response.data.success) {
                toast.success("Account Deleted Successfully")
            } else {
                toast.error("Failed to delete account")
            }
        } catch (error) {
            console.log(error)
        }
        toast.dismiss(toastId)
    }
}